/**
 * Defines products to be configured.
 * @type {string}
 */
export const CONFIGURATOR_PRODUCT = 'CONFIGURATOR_PRODUCT';
export const CONFIGURATOR_ADD_ITEM = 'CONFIGURATOR_ADD_ITEM';
export const CONFIGURATOR_REMOVE_ITEM = 'CONFIGURATOR_REMOVE_ITEM';
export const CONFIGURATOR_CHANGED_ITEM = 'CONFIGURATOR_CHANGED_ITEM';
export const CONFIGURATOR_UPDATE_QUANTITY = 'CONFIGURATOR_UPDATE_QUANTITY';
export const CONFIGURATOR_CLEAR = 'CONFIGURATOR_CLEAR';
export const CONFIGURATOR_CLEAR_CHANGED_ITEM = 'CONFIGURATOR_CLEAR_CHANGED_ITEM';
export const CONFIGURATOR_CLEAR_BUNDLE = 'CONFIGURATOR_CLEAR_BUNDLE';
export const SHOW_HELP = 'SHOW_HELP';
export const HIDE_HELP = 'HIDE_HELP';

/**
 * Defines order item configuration update.
 * @type {string}
 */
export const CONFIGURATOR_UPDATE_ITEM = 'CONFIGURATOR_UPDATE_ITEM';
export const CONFIGURATOR_SET_ORDER_ITEM_UPDATE = 'CONFIGURATOR_SET_ORDER_ITEM_UPDATE';

export default {
  CONFIGURATOR_PRODUCT,
  CONFIGURATOR_UPDATE_ITEM,
  CONFIGURATOR_ADD_ITEM,
  CONFIGURATOR_REMOVE_ITEM,
  CONFIGURATOR_CHANGED_ITEM,
  CONFIGURATOR_UPDATE_QUANTITY,
  CONFIGURATOR_CLEAR_CHANGED_ITEM,
  CONFIGURATOR_CLEAR,
  SHOW_HELP,
  HIDE_HELP,
  CONFIGURATOR_SET_ORDER_ITEM_UPDATE,
  CONFIGURATOR_CLEAR_BUNDLE,
};



// WEBPACK FOOTER //
// ./src/apps/configurator/store/types.js